export default {
  child_edition: {
    id: 13,
    first_name: 'Imię',
    last_name: 'Nazwisko',
    birthdate: '2010-11-11',
    created_at: '2022-03-07T12:26:42+01:00',
    gender: {
      id: 2,
      value: 'male'
    },
    pesel: null,
    school_class: 6,
    seniority: 1,
    wio_struct_location_id: 2151,
    wio_struct_location_name: 'Szkoła Testowa',
    edition: {
      id: 1,
      name: '2022'
    },
    status: {
      id: 1,
      description: 'Nowe',
      color: 'A7DAE0'
    },
    child_edition_guardian: {
      created_at: '2022-03-02T14:28:28+01:00',
      modified_at: '2022-03-02T14:28:28+01:00',
      first_name: 'Imię',
      last_name: 'Nazwisko',
      phone_number: '123123123',
      email: 'example@mail.com'
    },
    documents: [
      {
        id: 10877,
        type: 'guardian_consent',
        status: {
          id: 1,
          value: 'to_accept',
          display_value: 'Do akceptacji',
          color: 'F7CDAA'
        }
      }
    ],
    changelogs: [
      {
        id: 7,
        action: {
          created_at: '2022-03-02T13:28:28+01:00',
          modified_at: '2022-03-02T13:28:28+01:00',
          description: 'Dodanie Dziecka do systemu',
          full_name: 'Adam Sadam'
        },
        created_at: '2022-03-02T14:28:28+01:00',
        modified_at: '2022-03-02T14:28:28+01:00'
      }
    ],
    avatar_id: 3
  },
  school_hydra_users: {
    leaders: [
      {
        id: 666509,
        first_name: 'test',
        last_name: 'test',
        email: 'test@test',
        phone: '123123122'
      }
    ],
    coordinators: [
      {
        id: 666509,
        first_name: 'teste',
        last_name: 'test',
        email: 'test@test',
        phone: '123123122'
      }
    ]
  }
}
